import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const P = ({ children }) => (
  <p className="text-[15px] leading-[1.75] text-[var(--ink2)] mt-4">{children}</p>
);

export default function Contact() {
  return (
    <div data-testid="contact-page" className="min-h-screen bg-[var(--paper)] text-[var(--ink)]">
      <Navbar />
      <main className="max-w-[720px] mx-auto px-6 sm:px-10 py-24">
        <span className="eyebrow">◆ Legal</span>
        <h1 className="h-display text-[44px] sm:text-[56px] mt-3 leading-[1.05]">Contact for Support</h1>
        <p className="mono text-[11px] tracking-[0.18em] uppercase text-[var(--ink3)] mt-6">
          Last updated · August 1, 2026
        </p>

        <P>
          For any inquiry or grievance, you can contact our customer support team.
        </P>
        <P>
          <strong>Address for grievances:</strong>
        </P>
        <address className="text-[15px] leading-[1.75] text-[var(--ink2)] not-italic mt-2">
          103, Sonmarg CHS Ltd, Main Kasturba Road, Mumbai,<br />
          Maharashtra, India &ndash; 400066
        </address>
        <P>
          <strong>Email:</strong> <a href="mailto:hello@nirno.co.in" className="underline hover:text-[var(--red)]">hello@nirno.co.in</a>
        </P>
        <P>
          We aim to respond to all queries within 2&ndash;3 business days.
        </P>
      </main>
      <Footer />
    </div>
  );
}
